/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Typography from '@material-ui/core/Typography';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import Dashboard from '@material-ui/icons/Dashboard';
import Poll from '@material-ui/icons/Poll';
import Help from '@material-ui/icons/Help';
import BallotIcon from '@material-ui/icons/Ballot';
import Group from '@material-ui/icons/Group';
import GroupAdd from '@material-ui/icons/GroupAdd';
import Assignment from '@material-ui/icons/Assignment';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import FileCopy from '@material-ui/icons/FileCopy';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  Folder,
  FolderShared,
  Notifications,
} from '@material-ui/icons';
import MenuItem from './MenuItem';

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    overflow: 'auto',
  },
  drawerHeader: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    paddingLeft: '1em',
    ...theme.mixins.toolbar,
  },
  menuTitle: {
    fontFamily: 'Roboto',
    color: '#0000008a',
  },
  menuSubtitle: {
    fontSize: '0.75rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
  menuCategories: {
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
}));

const MenuCustomerEW = ({
  handleDrawerClose, company,
}) => {
  const classes = useStyles();
  // const [elearningOpen, setElearningOpen] = useState(false);
  // const [resultsOpen, setResultsOpen] = useState(false);
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const [archivesOpen, setArchivesOpen] = useState(false);

  return (
    <div className={classes.drawerContainer}>
      <div className={classes.drawerHeader}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
        <Grid container>
          <Grid item md={12}>
            <Typography component="p" variant="body1" className={classes.menuTitle}>
              {company && company.name}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <Divider />
      <List>
        <ListItem
          component={Link}
          to="/home"
          button
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText primary="Tableau de bord" />
        </ListItem>
        <ListItem
          component={Link}
          to="/customer/informations"
          button
        >
          <ListItemIcon>
            <BallotIcon />
          </ListItemIcon>
          <ListItemText primary="Mes informations" />
        </ListItem>
        <ListItem
          onClick={() => setDocumentsOpen(!documentsOpen)}
          button
        >
          <ListItemIcon>
            <FileCopy />
          </ListItemIcon>
          <ListItemText primary="Documents" />
          {documentsOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={documentsOpen} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem
              name="Documents"
              selectedRoute=""
              handleDrawerClose={() => {}}
              route="/documents"
              icon={<FolderShared />}
            />
            <MenuItem
              name="Proposition(s) de groupe(s)"
              selectedRoute=""
              handleDrawerClose={() => {}}
              route="/customer/proposals"
              icon={<GroupAdd />}
            />
            <MenuItem
              name="Plan(s) de formation"
              selectedRoute=""
              handleDrawerClose={() => {}}
              route="/customer/list/courseplan"
              icon={<Assignment />}
            />
            <MenuItem
              name="Rapport(s) de fin de formation"
              selectedRoute=""
              handleDrawerClose={() => {}}
              route="/customer/list/reports"
              icon={<AssignmentTurnedIn />}
            />
            <MenuItem
              name="Enquête(s) de satisfaction"
              selectedRoute=""
              handleDrawerClose={() => {}}
              route="/customer/survey"
              icon={<Poll />}
            />
          </List>
          <Divider />
        </Collapse>
        <ListItem
          component={Link}
          to="/customer/students"
          button
        >
          <ListItemIcon>
            <AssignmentIndIcon />
          </ListItemIcon>
          <ListItemText primary="Liste des stagiaires" />
        </ListItem>
        <ListItem
          component={Link}
          to="/groups"
          button
        >
          <ListItemIcon>
            <Group />
          </ListItemIcon>
          <ListItemText primary="Liste des formations" />
        </ListItem>
        <ListItem
          onClick={() => setArchivesOpen(!archivesOpen)}
          button
        >
          <ListItemIcon>
            <Folder />
          </ListItemIcon>
          <ListItemText primary="Archives" />
          {archivesOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={archivesOpen} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem
              name="Notifications"
              selectedRoute=""
              handleDrawerClose={() => { }}
              route="/customer/archives/notifications"
              icon={<Notifications />}
            />
          </List>
          <Divider />
        </Collapse>
        <ListItem
          component={Link}
          to="/help"
          button
        >
          <ListItemIcon>
            <Help />
          </ListItemIcon>
          <ListItemText primary="Assistance" />
        </ListItem>
      </List>
    </div>
  );
};

MenuCustomerEW.propTypes = {
  handleDrawerClose: PropTypes.func.isRequired,
};

export default MenuCustomerEW;
